// 运行按钮图标
export const RunIcon = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path d="M0 0h14v14H0z" />
    <path fill="#08f" d="m10.102 6.911-5.04 3.273V3.64z" />
    <path
      fill="#08f"
      d="M1.79 5.496a1.007 1.007 0 1 1-.953-.327 6.553 6.553 0 0 1 12.177-.778l-.913.428a5.54 5.54 0 0 0-5.023-3.196A5.55 5.55 0 0 0 1.79 5.496m10.442 3.008a1.006 1.006 0 0 1 .759-1.67 1.008 1.008 0 0 1 .194 1.997 6.556 6.556 0 0 1-12.177.779l.913-.428a5.54 5.54 0 0 0 5.023 3.197 5.55 5.55 0 0 0 5.288-3.875"
    />
  </svg>
);

// 组合运算按钮图标
export const MulRunIcon = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path d="M0 0h14v14H0z" />
    <path
      fill="#dc6e05"
      d="M11.116 10.5h1.316c.28 0 .532.224.532.532v1.316c0 .28-.224.532-.532.532h-1.316a.53.53 0 0 1-.532-.532v-.532h-.252A1.314 1.314 0 0 1 9.016 10.5V8.4H7.7v2.632c0 .28-.224.532-.532.532H1.652a.53.53 0 0 1-.532-.532V5.488c0-.28.224-.532.532-.532h2.632V2.604H1.652a.515.515 0 0 1-.532-.532V1.54c0-.28.224-.532.532-.532h10.78c.28 0 .532.224.532.532v.532c0 .28-.224.532-.532.532H4.536v2.38h2.632c.28 0 .532.224.532.532V8.12h1.316v-2.1c0-.728.588-1.316 1.316-1.316h.252v-.532c0-.28.224-.532.532-.532h1.316c.28 0 .532.224.532.532v1.316c0 .28-.224.532-.532.532h-1.316a.53.53 0 0 1-.532-.532v-.532h-.252c-.588 0-1.064.476-1.064 1.064v2.1h1.316v-.532c0-.28.224-.532.532-.532h1.316c.28 0 .532.224.532.532v1.316c0 .28-.224.532-.532.532h-1.316a.53.53 0 0 1-.532-.532V8.4H9.268v2.1c0 .588.476 1.064 1.064 1.064h.252v-.532c0-.308.252-.532.532-.532"
    />
    <path fill="#fff" d="m6.594 8.337-3.668 2.38v-4.76z" />
  </svg>
);

// 修改任务名称图标
export const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14">
    <rect width="6.3" height="1.4" x="7.7" y="11.7" rx=".3" ry=".3" fill="#8c0078" />
    <rect width="3.5" height="1.4" x="10.5" y="8.9" rx=".3" ry=".3" fill="#8c0078" />
    <path
      d="M12.1 3.6 9.6 1.1c-.5-.5-1.4-.5-1.8 0L.4 8.4c-.3.4-.3.7-.3 1.1v2.9c0 .5.5 1 1.1 1h2.9c.3 0 .6-.2.9-.4l7.3-7.3c.4-.6.4-1.5 0-2Zm-8.2 8.1H1.4V9.3L6.7 4l2.5 2.4zm6.2-6.2L7.7 3.1l1-1 2.4 2.4z"
      fill="#8c0078"
    />
  </svg>
);
// 查看结果按钮图标
export const ResultIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14">
    <g fill="#00CA95">
      <path d="M14 7c0-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.1 0-.1 0 0 0-.2-.1-.3-.2-.3-.4-.5-1-1-1.5-1.4-1.2-.9-2.5-1.7-4-2-.8-.3-1.6-.3-2.5-.2-.8.1-1.5.4-2.2.8-1.1.6-2.1 1.3-3 2.2-.1.2-.3.4-.5.5-.1.3-.1.5 0 .8.4.5 1 1 1.5 1.4 1.2.9 2.5 1.7 4 2 .8.2 1.7.2 2.6 0 .8-.1 1.5-.4 2.2-.8 1.1-.6 2.1-1.3 3-2.2l.5-.5s.1-.1.1-.2V7c0 .1 0 .1 0 0zM7 9.7C5.5 9.7 4.3 8.5 4.3 7c0-1.5 1.2-2.7 2.7-2.7S9.7 5.5 9.7 7 8.5 9.7 7 9.7z" />
      <circle cx="7" cy="7" r=".9" />
    </g>
  </svg>
);

// 复制按钮图标
export const CopyIcon = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path d="M0 0h14v14H0z" />
    <path
      fill="#ffb90b"
      d="M11.207 10.318a.64.64 0 0 1-.665-.623.64.64 0 0 1 .623-.665h.042c.343 0 .623-.28.623-.623V2.793a.624.624 0 0 0-.623-.623H5.6a.624.624 0 0 0-.623.623.64.64 0 0 1-.623.665.64.64 0 0 1-.665-.623v-.042A1.92 1.92 0 0 1 5.607.875h5.607a1.92 1.92 0 0 1 1.918 1.918V8.4a1.92 1.92 0 0 1-1.918 1.918z"
    />
    <path
      fill="#ffb90b"
      d="M8.274 13.125H2.905a2.03 2.03 0 0 1-2.03-2.023v-5.39c0-1.12.903-2.03 2.023-2.03h5.369a2.03 2.03 0 0 1 2.03 2.023v5.39a2.01 2.01 0 0 1-1.995 2.03h-.035zM2.898 4.977a.737.737 0 0 0-.735.721v5.404c0 .399.322.728.721.735h5.383a.737.737 0 0 0 .735-.721V5.712a.737.737 0 0 0-.721-.735H2.898"
    />
    <path
      fill="#ffb90b"
      d="M4.2 7.707a.71.71 0 0 0 .658-.462h1.771c.252 0 .462.21.462.462v.798a.923.923 0 0 0-.462-1.722H4.858a.69.69 0 0 0-.658-.462c-.308 0-.693.315-.693.693a.7.7 0 0 0 .693.693m0-.924c.126 0 .231.105.231.231a.233.233 0 0 1-.231.231.233.233 0 0 1-.231-.231c0-.126.105-.231.231-.231M6.979 9.1a.71.71 0 0 0-.658.462H4.438a.466.466 0 0 1-.462-.462v-.798a.92.92 0 0 0-.462.798c0 .511.42.924.924.924h1.883c.091.266.35.462.658.462s.693-.315.693-.693a.7.7 0 0 0-.693-.693m0 .924a.233.233 0 0 1-.231-.231c0-.126.105-.231.231-.231s.231.105.231.231a.233.233 0 0 1-.231.231"
    />
  </svg>
);

// 导入按钮图标
export const ImportIcon = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path d="M0 0h13v13H0z" />
    <path fill="#b006da" d="M8.81 1.723h2.987v.788H8.81z" />
    <path
      fill="#b006da"
      d="M11.056 2.44h.74v8.892h-.74zm-9.632 8.151h9.632v.741H1.424zm0-3.705h.74v3.705h-.74zM5.885 8.905l3.25-3.707H2.634z"
    />
    <path
      fill="#b006da"
      d="M4.641 5.216h2.971c-.575-2.01-2.548-3.493-4.896-3.493-.516 0-1.015.072-1.485.206 1.664.472 2.962 1.719 3.41 3.287"
    />
  </svg>
);

// 创建设计值按钮图标
export const CreatDesignIcon = () => (
  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path d="M0 0h13v13H0z" />
    <circle cx="7" cy="7" r="6.5" stroke="#626ad3" strokeWidth="1.2" fill="none" />
    <path d="M7 2.5v9M2.5 7h9" stroke="#626ad3" strokeWidth="1.2" />
  </svg>
);

// 删除按钮图标
export const DeleteIcon = () => (
  <svg width="14" height="14" fill="none" stroke="#FF0000" strokeWidth="1.2" viewBox="0 0 14 14">
    <path d="M2.5 4.5h9v8h-9z" />
    <path d="M1.5 3.5h11" />
    <path d="M1.5 3.5l1 1h9l1-1" />
    <path d="M5 2.2h4v1.3H5z" />
  </svg>
);

// 下拉按钮图标
export const UpDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14">
    <circle cx="2.5" cy="6.9" r="2" fill="#b0b0b0" />
    <circle cx="7" cy="7" r="2" fill="#b0b0b0" />
    <circle cx="11.5" cy="7.1" r="2" fill="#b0b0b0" />
  </svg>
);
